import { createAction, props } from '@ngrx/store';
import { OverviewToolbarState } from './overview-toolbar.reducer';

export const changeSpace = createAction(
  '[OverviewToolbar] Space changed',
  props<{ data: OverviewToolbarState }>(),
);
